function normalizeAvatarCandidate(value?: string | null): string | null {
  if (!value) return null;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
}

export function isValidAvatarUrl(value?: string | null): boolean {
  const candidate = normalizeAvatarCandidate(value);
  if (!candidate) return false;

  if (candidate.startsWith('/')) return true;
  if (candidate.startsWith('data:image/')) return true;

  try {
    const parsed = new URL(candidate);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:';
  } catch {
    return false;
  }
}

export function getValidAvatarUrl(
  primary?: string | null,
  secondary?: string | null,
): string | null {
  const first = normalizeAvatarCandidate(primary);
  if (isValidAvatarUrl(first)) return first;

  const second = normalizeAvatarCandidate(secondary);
  if (isValidAvatarUrl(second)) return second;

  return null;
}

type DiscoverAvatarUser = {
  prof_pics?: string | null;
  prof_pics_url?: string | null;
  google_prof_pics?: string | null;
};

export function getDiscoverAvatarUrl(user?: DiscoverAvatarUser | null): string | null {
  if (!user) return null;
  // Prioritize prof_pics (Cloudinary) -> prof_pics_url (legacy) -> google_prof_pics
  return (
    getValidAvatarUrl(user.prof_pics) ||
    getValidAvatarUrl(user.prof_pics_url) ||
    getValidAvatarUrl(user.google_prof_pics)
  );
}
